/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataJobEnum } from './DataJobEnum';
import { DataJobEnumFromJSON, DataJobEnumFromJSONTyped, DataJobEnumToJSON } from './DataJobEnum';
import type { DatasetPipelineStatus } from './DatasetPipelineStatus';
import {
  DatasetPipelineStatusFromJSON,
  DatasetPipelineStatusFromJSONTyped,
  DatasetPipelineStatusToJSON,
} from './DatasetPipelineStatus';
import type { AssessmentShallow } from './AssessmentShallow';
import {
  AssessmentShallowFromJSON,
  AssessmentShallowFromJSONTyped,
  AssessmentShallowToJSON,
} from './AssessmentShallow';
import type { AiModelName } from './AiModelName';
import { AiModelNameFromJSON, AiModelNameFromJSONTyped, AiModelNameToJSON } from './AiModelName';
import type { PerturbedDatasetPolymorphic } from './PerturbedDatasetPolymorphic';
import {
  PerturbedDatasetPolymorphicFromJSON,
  PerturbedDatasetPolymorphicFromJSONTyped,
  PerturbedDatasetPolymorphicToJSON,
} from './PerturbedDatasetPolymorphic';
import type { DatasetPipelineInferencer } from './DatasetPipelineInferencer';
import {
  DatasetPipelineInferencerFromJSON,
  DatasetPipelineInferencerFromJSONTyped,
  DatasetPipelineInferencerToJSON,
} from './DatasetPipelineInferencer';
import type { DatasetPolymorphic } from './DatasetPolymorphic';
import {
  DatasetPolymorphicFromJSON,
  DatasetPolymorphicFromJSONTyped,
  DatasetPolymorphicToJSON,
} from './DatasetPolymorphic';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';
import type { GenerationInputsPolymorphic } from './GenerationInputsPolymorphic';
import {
  GenerationInputsPolymorphicFromJSON,
  GenerationInputsPolymorphicFromJSONTyped,
  GenerationInputsPolymorphicToJSON,
} from './GenerationInputsPolymorphic';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface DatasetPipelineDetail
 */
export interface DatasetPipelineDetail {
  /**
   *
   * @type {number}
   * @memberof DatasetPipelineDetail
   */
  readonly id: number;
  /**
   *
   * @type {AiModelName}
   * @memberof DatasetPipelineDetail
   */
  readonly aiModel: AiModelName;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof DatasetPipelineDetail
   */
  taskType?: TaskTypeEnum | null;
  /**
   *
   * @type {GenerationInputsPolymorphic}
   * @memberof DatasetPipelineDetail
   */
  readonly generationInputs: GenerationInputsPolymorphic;
  /**
   *
   * @type {DatasetPipelineInferencer}
   * @memberof DatasetPipelineDetail
   */
  inferencer: DatasetPipelineInferencer;
  /**
   *
   * @type {Array<Perturbation>}
   * @memberof DatasetPipelineDetail
   */
  readonly perturbations: Array<Perturbation>;
  /**
   *
   * @type {DatasetPolymorphic}
   * @memberof DatasetPipelineDetail
   */
  readonly dataset: DatasetPolymorphic;
  /**
   *
   * @type {Array<PerturbedDatasetPolymorphic>}
   * @memberof DatasetPipelineDetail
   */
  readonly perturbedDatasets: Array<PerturbedDatasetPolymorphic>;
  /**
   *
   * @type {string}
   * @memberof DatasetPipelineDetail
   */
  taskName?: string | null;
  /**
   *
   * @type {string}
   * @memberof DatasetPipelineDetail
   */
  celeryTask?: string | null;
  /**
   *
   * @type {number}
   * @memberof DatasetPipelineDetail
   */
  readonly progress: number | null;
  /**
   *
   * @type {Date}
   * @memberof DatasetPipelineDetail
   */
  readonly startTime: Date | null;
  /**
   *
   * @type {Date}
   * @memberof DatasetPipelineDetail
   */
  readonly endTime: Date | null;
  /**
   *
   * @type {number}
   * @memberof DatasetPipelineDetail
   */
  readonly estimatedTime: number | null;
  /**
   *
   * @type {string}
   * @memberof DatasetPipelineDetail
   */
  readonly errorMessage: string | null;
  /**
   *
   * @type {DataJobEnum}
   * @memberof DatasetPipelineDetail
   */
  dataJob?: DataJobEnum | null;
  /**
   *
   * @type {DatasetPipelineStatus}
   * @memberof DatasetPipelineDetail
   */
  readonly status: DatasetPipelineStatus | null;
  /**
   *
   * @type {Date}
   * @memberof DatasetPipelineDetail
   */
  readonly timestamp: Date;
  /**
   *
   * @type {Array<AssessmentShallow>}
   * @memberof DatasetPipelineDetail
   */
  readonly assessments: Array<AssessmentShallow>;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPipelineDetail
   */
  readonly hasAssessments: boolean;
}

/**
 * Check if a given object implements the DatasetPipelineDetail interface.
 */
export function instanceOfDatasetPipelineDetail(value: object): value is DatasetPipelineDetail {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('aiModel' in value) || value['aiModel'] === undefined) return false;
  if (!('generationInputs' in value) || value['generationInputs'] === undefined) return false;
  if (!('inferencer' in value) || value['inferencer'] === undefined) return false;
  if (!('perturbations' in value) || value['perturbations'] === undefined) return false;
  if (!('dataset' in value) || value['dataset'] === undefined) return false;
  if (!('perturbedDatasets' in value) || value['perturbedDatasets'] === undefined) return false;
  if (!('progress' in value) || value['progress'] === undefined) return false;
  if (!('startTime' in value) || value['startTime'] === undefined) return false;
  if (!('endTime' in value) || value['endTime'] === undefined) return false;
  if (!('estimatedTime' in value) || value['estimatedTime'] === undefined) return false;
  if (!('errorMessage' in value) || value['errorMessage'] === undefined) return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
  if (!('assessments' in value) || value['assessments'] === undefined) return false;
  if (!('hasAssessments' in value) || value['hasAssessments'] === undefined) return false;
  return true;
}

export function DatasetPipelineDetailFromJSON(json: any): DatasetPipelineDetail {
  return DatasetPipelineDetailFromJSONTyped(json, false);
}

export function DatasetPipelineDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetPipelineDetail {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    aiModel: AiModelNameFromJSON(json['ai_model']),
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
    generationInputs: GenerationInputsPolymorphicFromJSON(json['generation_inputs']),
    inferencer: DatasetPipelineInferencerFromJSON(json['inferencer']),
    perturbations: (json['perturbations'] as Array<any>).map(PerturbationFromJSON),
    dataset: DatasetPolymorphicFromJSON(json['dataset']),
    perturbedDatasets: (json['perturbed_datasets'] as Array<any>).map(PerturbedDatasetPolymorphicFromJSON),
    taskName: json['task_name'] == null ? undefined : json['task_name'],
    celeryTask: json['celery_task'] == null ? undefined : json['celery_task'],
    progress: json['progress'],
    startTime: json['start_time'] == null ? null : new Date(json['start_time']),
    endTime: json['end_time'] == null ? null : new Date(json['end_time']),
    estimatedTime: json['estimated_time'],
    errorMessage: json['error_message'],
    dataJob: json['data_job'] == null ? undefined : DataJobEnumFromJSON(json['data_job']),
    status: DatasetPipelineStatusFromJSON(json['status']),
    timestamp: new Date(json['timestamp']),
    assessments: (json['assessments'] as Array<any>).map(AssessmentShallowFromJSON),
    hasAssessments: json['has_assessments'],
  };
}

export function DatasetPipelineDetailToJSON(
  value?: Omit<
    DatasetPipelineDetail,
    | 'id'
    | 'aiModel'
    | 'generationInputs'
    | 'perturbations'
    | 'dataset'
    | 'perturbedDatasets'
    | 'progress'
    | 'startTime'
    | 'endTime'
    | 'estimatedTime'
    | 'errorMessage'
    | 'status'
    | 'timestamp'
    | 'assessments'
    | 'hasAssessments'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    inferencer: DatasetPipelineInferencerToJSON(value['inferencer']),
    task_name: value['taskName'],
    celery_task: value['celeryTask'],
    data_job: DataJobEnumToJSON(value['dataJob']),
  };
}
